/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

export default {
  getFoundationUsers: (params) => {
    return axios.get(API_ENDPOINTS.FOUNDATION_USERS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
      params,
    });
  },
  getFoundationRoles: () => {
    return axios.get(API_ENDPOINTS.FOUNDATION_ROLES, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  createFoundationRole: (data) => {
    return axios.post(API_ENDPOINTS.FOUNDATION_ROLES, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
};
